import {createFileRoute} from '@tanstack/react-router';
import {InvoiceAccountCloseSuccessPage} from 'features/one-time-credit/pages/InvoiceAccountClosePage/InvoiceAccountCloseSuccessPage';

export const Route = createFileRoute(
  '/_protected/accounts/invoices/$accountId/close/success',
)({
  component: InvoiceAccountCloseSuccessPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      action: search.action as string | undefined,
      accountName: search.accountName as string | undefined,
    };
  },
});
